import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { PluggableList } from 'react-markdown/lib/react-markdown';
import ReactMarkdown from 'react-markdown';
import { useIntl } from 'react-intl';
import rehypeSlug from 'rehype-slug';
import markdown from '../data/staticPages/terms-of-use.md';
import Layout from '../components/Layout';
import LinkAndAnchor from '../components/LinkAndAnchor';
import messages from '../lib/messages.json';
import HomeLink from '../components/HomeLink';
import Head from '../components/Head';

const TermsOfUsePage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="terms-of-use"
      passHref
    >
      {intl.formatMessage(messages['info.conditions.termsOfUse'])}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages['info.conditions.termsOfUse'])}
        description={intl.formatMessage(messages['info.conditions.termsOfUse'])}
      />
      <StaticPageComponent
        content={(
          <ReactMarkdown
            rehypePlugins={
              [rehypeSlug] as PluggableList
            }
          >
            {markdown}
          </ReactMarkdown>
          )}
        title={intl.formatMessage(messages['info.conditions.termsOfUse'])}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

TermsOfUsePage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default TermsOfUsePage;
